export default __webpack_public_path__ + "static/media/phish-in-logo.06a5731e.png";